import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { bookingShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import { Column } from 'components/shared/Layout';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { sum, subtract } from 'utils/calculator';

import {
  StyledBody,
  StyleHeaderItems,
  StyleHeaderItem,
  StyledCostRow
} from 'components/ui/BookingPathReviewBookingSummary/BookingPathReviewBookingSummary.styles';

import SectionHeaderTitle from 'components/ui/BookingPathReviewBookingSummary/SectionHeaderTitle';

import SectionHeaderBar from 'components/ui/BookingPathReviewBookingSummary/SectionHeaderBar';

import { BoldFormattedCurrency, BorderedRow } from './ReviewExtrasCost.styles';

const ReviewExtrasCost = ({ title, booking = {} }) => {
  const [isActive, setIsActive] = useState(true);

  const { currency, outboundExtras, inboundExtras } = booking;

  const cancelledOutboundExtras = outboundExtras.filter((extra) => extra.cancelled && extra.provisional);
  const newOutboundExtras = outboundExtras.filter((extra) => !extra.cancelled && extra.provisional);
  const cancelledInboundExtras = inboundExtras.filter((extra) => extra.cancelled && extra.provisional);
  const newInboundExtras = inboundExtras.filter((extra) => !extra.cancelled && extra.provisional);

  const cancelledExtrasPrice = sum([...cancelledOutboundExtras, ...cancelledInboundExtras].map((e) => e.price));
  const newExtrasPrice = sum([...newOutboundExtras, ...newInboundExtras].map((e) => e.price));
  const totalPrice = subtract(newExtrasPrice, cancelledExtrasPrice);

  return (
    <>
      <SectionHeaderBar>
        <SectionHeaderTitle titleId={title} isActive={isActive} setIsActive={setIsActive} />
        <StyleHeaderItems className="booking-total">
          <FormattedMessage id="summary.total" />
          <StyleHeaderItem data-testid="summary-price">
            <FormattedCurrency amount={totalPrice} currency={currency} />
          </StyleHeaderItem>
        </StyleHeaderItems>
      </SectionHeaderBar>
      <StyledBody data-testid="cost-of-changing-extras" hide={!isActive}>
        <StyledCostRow>
          <Column span={4}>
            <FormattedMessage id="extras.cancelledExtras" />
          </Column>
          <Column span={4} data-testid="cancelled-extras-cost">
            <FormattedCurrency amount={cancelledExtrasPrice} currency={currency} />
          </Column>
        </StyledCostRow>
        <StyledCostRow>
          <Column span={4}>
            <FormattedMessage id="extras.newExtras" />
          </Column>
          <Column span={4} data-testid="new-extras-cost">
            <FormattedCurrency amount={newExtrasPrice} currency={currency} />
          </Column>
        </StyledCostRow>
        <BorderedRow>
          <Column span={4}>
            <FormattedMessage id="journeySegment.totalPrice" />
          </Column>
          <Column span={4} data-testid="total-extras-cost">
            <BoldFormattedCurrency amount={totalPrice} currency={currency} />
          </Column>
        </BorderedRow>
      </StyledBody>
    </>
  );
};

ReviewExtrasCost.propTypes = {
  title: PropTypes.string,
  booking: bookingShape
};

export default ReviewExtrasCost;
